import {
    SigningModeType,
    MixpanelTriggerType,
    MixpanelProviderType,
    MIXPANEL_STEP_TYPE_MAP,
    FunnelType,
} from '@fiverr-private/identification_core';

export { MixpanelProviderType };

export type MixpanelStepType = ValueOf<typeof MIXPANEL_STEP_TYPE_MAP>;
export type MixpanelSigningModeType = ValueOf<typeof MIXPANEL_SIGNING_MODE_TYPE_MAP>;
export type MixpanelSigningFlowType = 'Sign In' | 'Sign Up' | 'Social Sign Up' | 'Social';
export type Provider = 'standard' | 'google' | 'facebook' | 'apple';

export interface MixpanelEventProperties {
    mode: MixpanelSigningModeType;
    provider: MixpanelProviderType;
    flow: MixpanelSigningFlowType;
    pageName: string;
    errorType: string;
    triggerType: MixpanelTriggerType;
    triggerId: string;
    triggerCopy: string;
    triggerPlacement: string;
    triggerComments: string;
    redirectUrl: string;
    step: MixpanelStepType;
    experience: 'Identification';
    funnel: FunnelType;
    emailDomain: string;
    viewType: string;
    sourceComponent: string;
    package: string;
}

export const MIXPANEL_SIGNING_MODE_TYPE_MAP = {
    sign_in: 'Sign In',
    sign_up: 'Sign Up',
} as const satisfies Record<SigningModeType, string>;

export const INITIAL_CONTEXT = {
    package: '@fiverr-private/identification_marketplace',
} as const;
